import { useState } from "react";
import { Dashboard } from "./Dashboard";
import { Jobs } from "./Jobs";
import { History } from "./History";
import { Gaps } from "./Gaps";
import { Settings } from "./Settings";
import { Users } from "./Users";
import { RunLog } from "./RunLog";

type Page = "dashboard" | "jobs" | "runs" | "missing" | "settings" | "users";

const NAMES: Record<Page, string> = {
  dashboard: "Dashboard",
  jobs: "Jobs",
  runs: "History",
  missing: "Missing info",
  settings: "Schedules & limits",
  users: "Users",
};

/**
 * The admin panel.
 *
 * The run log is a drawer rather than a page: pressing Run and being taken
 * away from the job list is the wrong thing, and watching a crawl while
 * starting another is the normal case. It opens from the job list, from the
 * run history and from a line in the log search, which is why it lives beside
 * the pages rather than inside one.
 */
export function Admin({ page: asked, go }: {
  /** The page named in the path: /admin/jobs -> "jobs". Unknown or missing is the dashboard. */
  page?: string;
  go: (path: string) => void;
}) {
  const page: Page = asked && asked in NAMES ? (asked as Page) : "dashboard";
  const [watching, setWatching] = useState<number | null>(null);

  return (
    <div className={`admin${watching ? " watching" : ""}`}>
      <nav className="subnav">
        {(Object.keys(NAMES) as Page[]).map((p) => (
          <button key={p} className={p === page ? "on" : ""}
                  onClick={() => go(p === "dashboard" ? "/admin" : `/admin/${p}`)}>
            {NAMES[p]}
          </button>
        ))}
      </nav>

      <div className="admin-body">
        <div className="admin-main">
          {page === "dashboard" && <Dashboard onWatch={setWatching} />}
          {page === "jobs" && <Jobs onWatch={setWatching} />}
          {page === "runs" && <History onWatch={setWatching} />}
          {page === "missing" && <Gaps onWatch={setWatching} />}
          {page === "settings" && <Settings />}
          {page === "users" && <Users />}
        </div>
        {watching !== null && (
          <RunLog id={watching} onClose={() => setWatching(null)} />
        )}
      </div>
    </div>
  );
}
